import React, { Component } from 'react';
import PropTypes from 'prop-types';

import {
  SR_API_ACTION_VERIFY_PHONE_SMS_CODE_REQUESTED,
  SR_API_ACTION_VERIFY_ACCOUNT_EXIST,
} from 'api/actionTypes';
import { SCREEN_ID_RESET_PASSWORD } from 'client/constants/screenIds';
import { USER_ROLE_ANONYMOUS } from 'common/userRoles';

import log from 'client/lib/log';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedRoles from 'client/helpers/allowedRoles';
import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';

import AuthActions from 'client/actions/Auth';

import SrPasswordResetSmsForm from 'client/components/SrPasswordResetSmsForm';
import SrSmsSendingIndicator from 'client/components/SrSmsSendingIndicator';
import Navbar from 'client/components/Navbar';
import SrLink from 'client/components/SrLink/SrLink';
import SrErrorMessage from 'client/components/SrErrorMessage/SrErrorMessage';

@withTransitionHook
@allowedRoles({
  roles: [
    USER_ROLE_ANONYMOUS,
  ],
  redirectUrl: '/',
})
@withApiState({
  verifyPhoneApiState: {
    action: SR_API_ACTION_VERIFY_PHONE_SMS_CODE_REQUESTED,
  },
})
@withScreenId(SCREEN_ID_RESET_PASSWORD)
@withScrollToTop
class ResetPasswordPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Sunroom Rentals',
    section: SCREEN_ID_RESET_PASSWORD,
    keywords: 'sunroom, reset password',
    description: 'Reset your sunroom password.',
  })

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    verifyPhoneApiState: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.state = {
      showSmsSending: false,
      phoneNumberDoesNotExist: false,
      phone: '',
    };
    this._unmounting = false;
    this._onRequestVerificationCode = this._onRequestVerificationCode.bind(this);
  }

  componentWillUnmount() {
    this._unmounting = true;
  }

  async _onRequestVerificationCode({ phone }) {
    const {
      dispatch,
      history,
      location,
    } = this.props;

    this.setState({
      showSmsSending: false,
      phoneNumberDoesNotExist: false,
      phone,
    });

    try {
      const userExist = await dispatch(postWithState, {
        action: SR_API_ACTION_VERIFY_ACCOUNT_EXIST,
        payload: {
          phone: phone,
        },
      });

      if (userExist) {
        await dispatch(AuthActions.resetPasswordSmsCodeRequested, {
          phone: phone,
        });

        this.setState({
          showSmsSending: true,
        });

        setTimeout(() => {
          if (!this._unmounting) {
            this.setState({
              showSmsSending: false,
            });
          }
          history.push(`/reset-password-verify-code${location.search}`);
        }, 3000);
      }
      else {
        this.setState({
          showSmsSending: false,
          phoneNumberDoesNotExist: true,
        });
      }
    }
    catch (error) {
      log.error(error);
    }
  }

  render() {
    const {
      verifyPhoneApiState,
    } = this.props;
    const {
      showSmsSending,
      phoneNumberDoesNotExist,
      phone,
    } = this.state;

    return (
      <div className='page-reset-password'>
        <Navbar
          redirectLogoTo='/'
          leftButton={
            <SrLink
              className='link back'
              redirectToLastLocation
              restoreScrollPosition
              to='/login'
            >
              Back
            </SrLink>
          }
        />
        <div className='resetContainer'>
          <div className='resetFormContainer'>
            {phoneNumberDoesNotExist && (
              <SrErrorMessage>
                Sorry, there is no account with that phone number
              </SrErrorMessage>
            )}
            {!verifyPhoneApiState.inProgress
              && !showSmsSending
              && (
                <SrPasswordResetSmsForm
                  onSubmit={this._onRequestVerificationCode}
                />
              )
            }
            {showSmsSending && (
              <SrSmsSendingIndicator
                phone={phone}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

ResetPasswordPage.displayName = 'ResetPasswordPage';

export default ResetPasswordPage;
